var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDragIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.188 5.625a.937.937 0 100-1.875.937.937 0 000 1.875zM12.813 5.625a.937.937 0 100-1.875.937.937 0 000 1.875zM7.188 10.938a.937.937 0 100-1.875.937.937 0 000 1.874zM12.813 10.938a.937.937 0 100-1.875.937.937 0 000 1.874zM7.188 16.25a.937.937 0 100-1.875.937.937 0 000 1.875zM12.813 16.25a.937.937 0 100-1.875.937.937 0 000 1.875z",
    fill: "#33647E"
  })));
}
export default SvgDragIcon;